export { default } from './propLowerEq';
